import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationTextMessage } from '@app/core/Enum';
import { CommonService } from '@app/core/Services';
import { SaveBankFeedsStartDate } from '@app/core/Store';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-startdate-popup',
  templateUrl: './startdate-popup.component.html',
  styleUrls: ['./startdate-popup.component.scss']
})
export class StartdatePopupComponent implements OnInit {

  bankFeedsStartDate: Date;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store,
    public dialogRef: MatDialogRef<StartdatePopupComponent>,
    private commonService: CommonService,
    private renderer: Renderer2,
   
  ) {}

  ngOnInit(): void {
    if (this.data?.bankFeedsStartDate) {
      this.bankFeedsStartDate = new Date(this.data.bankFeedsStartDate);
    }
  }

  bankFeedsStartDateSave(): void {
    if (!this.bankFeedsStartDate || isNaN(new Date(this.bankFeedsStartDate).getTime())) {
      this.commonService.onFailure(NotificationTextMessage.errorMessage);
      return;
    }

    const localDate = new Date(this.bankFeedsStartDate);
    const formattedDate = new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate()));

    const obj = {
      startDate: formattedDate,
      id: this.data?.id
    };

    this.store
      .dispatch(new SaveBankFeedsStartDate(obj))
      .subscribe((res) => {
        if (res?.bankReconciliation?.bankFeedsStartDate?.data) {
          this.commonService.onSucess(NotificationTextMessage.successMessage);
          this.dialogRef.close(true);
        } else {
          this.commonService.onFailure(NotificationTextMessage.errorMessage);
        }
      });
  }
}
